import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { PostNewUserQuery } from '@/services/post-new-user-query';
import _ from 'lodash';
import { computed, ref } from 'vue';

const currentQuery = ref('');
const currentEfq = ref('');
const isSpecialQuery = ref(false);
const currentOriginQuery = ref('');

const stream = injectService<PostNewUserQuery>(PostNewUserQuery).subject;

const searchQuery = ref('');

stream.subscribe(queryStateX => {
    if (queryStateX.query) {
        currentQuery.value = queryStateX.query;
    }
    searchQuery.value = queryStateX.search_query;
    currentEfq.value = queryStateX.filter || '';
    isSpecialQuery.value = !!queryStateX.isSpecialQuery;

    if (queryStateX.originQuery) {
        currentOriginQuery.value = queryStateX.originQuery;
    }
});

const queryForWorkspaceApi = computed(() => {
    return isSpecialQuery.value ? searchQuery.value : currentQuery.value;
});

function resetQueryStates() {
    currentQuery.value = '';
    currentEfq.value = '';
    isSpecialQuery.value = false;
    currentOriginQuery.value = '';
}

export function useQueryState() {
    return {
        /**
         * 长短转化后的 query
         */
        currentQuery,
        currentOriginQuery,
        /**
         * 长短转化后的 efq 原始文本
         */
        currentEfq,
        isSpecialQuery,
        /**
         * workspace api 专用
         */
        queryForWorkspaceApi,
        resetQueryStates,
    };
}
